import { render, staticRenderFns } from "./jyd.vue?vue&type=template&id=60d651e2&scoped=true&"
import script from "./jyd.vue?vue&type=script&lang=js&"
export * from "./jyd.vue?vue&type=script&lang=js&"
import style0 from "./jyd.vue?vue&type=style&index=0&id=60d651e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d651e2",
  null
  
)

export default component.exports